import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./modules/home/home.component').then(m => m.HomeComponent),
        data: { preload: true },
      },
      {
        path: 'services',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/services/services.component').then(m => m.ServicesComponent),
            data: { preload: true },
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./modules/services/project-details/project-details.component').then(m => m.ProjectDetailsComponent),
          },
        ],
      },
      {
        path: 'careers',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/careers/careers.component').then(m => m.CareersComponent),
            data: { preload: true },
          },
          {
            path: ':id',
            loadComponent: () => import('./modules/careers/career-details/career-details.component').then(m => m.CareerDetailsComponent),
          },
        ],
      },
      {
        path: 'about-us',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/about-us/about-us.component').then(m => m.AboutUsComponent),
            data: { preload: true },
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./modules/about-us/employee-details/employee-details.component').then(m => m.EmployeeDetailsComponent),
          },
        ],
      },
      {
        path: 'hire-us',
        loadComponent: () => import('./modules/hire-us/hire-us.component').then(m => m.HireUsComponent),
        data: { preload: true },
      },
      {
        path: 'not-found',
        loadComponent: () => import('./modules/not-found/not-found.component').then(m => m.NotFoundComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
